import _Student from './student';

export const Student = _Student;

export default Student;



// WEBPACK FOOTER //
// ./containers/Group/Homework/PaperBased/MarkHomeworkDayView/Student/index.js